// src/screens/HelpScreen.tsx
import React from "react";
import { View, Text, TouchableOpacity, Linking } from "react-native";
import { registrationStyles as styles } from "../styles/registrationStyles";
import HeaderBack from "../component/HeaderBack";
import { MessageCircle, Mail, Phone } from "lucide-react-native";
import { FlickOColors } from "../styles/color";
import { config } from "../../../config";

const HelpScreen = () => {
  const supportDetails = {
    whatsapp: config.support.num,
    email: config.support.email,
    phone: config.support.num,
  };

  const handleWhatsApp = () => {
    Linking.openURL(`whatsapp://send?phone=${supportDetails.whatsapp}`);
  };

  const handleEmail = () => {
    Linking.openURL(`mailto:${supportDetails.email}`);
  };

  const handleCall = () => {
    Linking.openURL(`tel:${supportDetails.phone}`);
  };

  return (
    <View style={styles.container}>
      <HeaderBack title="Help & Support" />

      <View style={styles.helpContent}>
        <Text style={styles.helpText}>
          Need assistance? Reach out to us through any of these channels:
        </Text>

        <View style={styles.contactOptions}>
          <TouchableOpacity style={styles.contactCard} onPress={handleWhatsApp}>
            <MessageCircle size={24} color={FlickOColors.success} />
            <View style={styles.contactInfo}>
              <Text style={styles.contactTitle}>Chat on WhatsApp</Text>
              <Text style={styles.contactDetail}>Quick responses</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity style={styles.contactCard} onPress={handleEmail}>
            <Mail size={24} color={FlickOColors.primary} />
            <View style={styles.contactInfo}>
              <Text style={styles.contactTitle}>Email Us</Text>
              <Text style={styles.contactDetail}>{supportDetails.email}</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity style={styles.contactCard} onPress={handleCall}>
            <Phone size={24} color={FlickOColors.blue} />
            <View style={styles.contactInfo}>
              <Text style={styles.contactTitle}>Call Us</Text>
              <Text style={styles.contactDetail}>{supportDetails.phone}</Text>
            </View>
          </TouchableOpacity>
        </View>

        <Text style={styles.supportHours}>
          Support available from 11:00 AM to 11:00 PM
        </Text>
      </View>
    </View>
  );
};

export default HelpScreen;
